import { CancelContractDataState } from '../states/cancel-contract-data.state';
import { CancelContractDataAction, CancelContractDataActionType } from '../actions/cancel-contract-data.actions';
/** CancelContractDataReducer */
export function CancelContractDataReducer (state: CancelContractDataState, action: CancelContractDataAction): CancelContractDataState {

    switch (action.type) {

        case CancelContractDataActionType.PERSONAL_INFORMATION:
            return {
                ...state,
                personalData: action.payload.personalData,
            };
        case CancelContractDataActionType.ADRESS_INFORMATION:
            return {
                ...state,
                AddressData: action.payload.AddressData,
            };
        case CancelContractDataActionType.CONTRACT_INFORMATION:
            return {
                ...state,
                ContractData: action.payload.ContractData,
            };
        default:
            return state;
    }
}
